(function(global) {
    var linksIndustry = document.querySelectorAll('.industry__nav a'),
        industry = document.querySelector('.industry'),
        isPreloaded = false;

    for (var i = 0, len = linksIndustry.length; i < len; i++) {
        linksIndustry[i].addEventListener('mouseenter', changeStateIndustry);
    }

    function changeStateIndustry() {
        var img = this.getAttribute('data-img');

        if (typeof img === 'string') {
            document.querySelector('.industry__media > div').style.backgroundImage = 'url("'+ img + '")';
        }
    }

    function preloadImages() {
        if (isScrolledIntoView(industry) && isPreloaded == false) {
            var images = [];

            for (var i = 0, len = linksIndustry.length; i < len; i++) {
                var img = linksIndustry[i].getAttribute('data-img');

                if (typeof img === 'string') {
                    images[i] = new Image();
                    images[i].src = img;
                }
            }

            isPreloaded = true;
        }
    }

    function isScrolledIntoView(el) {
        var rect = el.getBoundingClientRect(),
            elemTop = rect.top,
            elemBottom = rect.bottom,
            elemHeight = rect.height,
            isVisible = (elemTop >= 0) && (elemBottom - elemHeight <= window.innerHeight);

        return isVisible;
    }

    if (industry) {
        window.addEventListener('scroll', global.methods.debounce(preloadImages, 500));
    }

})(window.groots);
